import { Component } from "@/decorators";
import CestModel from "@/models/produto/cestModel";
import cestService from "@/services/produto/cestService";

import EditComponentBase from "../editComponentBase";

@Component
export default class CestEditComponent extends EditComponentBase<CestModel> {
    private async beforeMount() {
        await this.setPropsCached(cestService, "cests", new CestModel());
    }
}
